import { render, staticRenderFns } from "./PaymentMadeToAgreement.vue?vue&type=template&id=5622fa6c&"
import script from "./PaymentMadeToAgreement.vue?vue&type=script&lang=js&"
export * from "./PaymentMadeToAgreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports